export default {
  slug: "phpstorm",
  code: "PS",
  label: "PhpStorm",
  isIDE: true,
  krakenDir: "PhpStorm",
  thumbnailColor: "#FF318C",
  logoFamily: "ide",
  // The code highlight of the Demo Video banners (Figma "YouTube", "Code
  // highlight color" of the product section).
  codeHighlightColor: "#B74AF7",
};
